import { render } from "./IntersectionObserver.vue?vue&type=template&id=d010fe14"
import script from "./IntersectionObserver.vue?vue&type=script&lang=js"
export * from "./IntersectionObserver.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__